import { PropsWithChildren, useEffect, useLayoutEffect, useRef } from 'react';
import Cookies from 'js-cookie';

import { EuiProvider } from '@elastic/eui';

import { ChartStyleLoader } from '@/shared/contexts/theme/ChartStyleLoader';
import { useThemeStore, Theme } from '@/store';

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);
  const didInit = useRef(false);

  useEffect(() => {
    const cookieOptions: Cookies.CookieAttributes = {
      expires: 365,
      path: '/',
      secure: true,
      sameSite: 'none',
    };

    if (location.hostname.endsWith('elastic.co')) {
      cookieOptions.domain = 'elastic.co';
    }

    if (didInit.current) {
      Cookies.set('EUI_THEME', theme, cookieOptions);
      document.documentElement.dataset.theme = theme;
    }
  }, [theme]);

  useLayoutEffect(() => {
    const cookieTheme = Cookies.get('EUI_THEME') as Theme | undefined;
    if (cookieTheme) {
      setTheme(cookieTheme);
    }
    didInit.current = true;
  }, [setTheme]);

  return (
    <EuiProvider colorMode={theme}>
      <ChartStyleLoader />
      {children}
    </EuiProvider>
  );
};
